export default __webpack_public_path__ + "static/media/3-cloudxier-PLN-mockup02.527411b6.jpg";